import { useDeviceTypeContext, useStyles } from '@archipro-design/aria';
import {
    HeadingModuleContainer,
    HeadingModuleLogoContainer,
} from './HeadingModule.style';
import type { HeadingModuleProps } from '@modules/elemental-page/type';
import { LogoAnimated } from '../../../../../../rocco/src/components/logo-animated/LogoAnimated';

import type { JSX } from 'react';

const HeadingModule = ({
    title,
    headingLevel = 'h2',
    anchor,
    noNavigation = false,
}: HeadingModuleProps) => {
    const { css } = useStyles({ noNavigation: noNavigation });
    const HeadingTag = headingLevel as keyof JSX.IntrinsicElements;
    const { mobile } = useDeviceTypeContext();

    return (
        <div id={anchor} className={css(HeadingModuleContainer)}>
            {title ? (
                <HeadingTag>{title}</HeadingTag>
            ) : (
                <div className={css(HeadingModuleLogoContainer)}>
                    <LogoAnimated
                        size={mobile ? 3 : 9}
                        mode="disabled"
                        color="dark"
                    />
                </div>
            )}
        </div>
    );
};

export default HeadingModule;
